import React, { useContext } from "react";


import { Permissions } from "@/lib/permissions";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";

import UserContext from "@/components/UserContext/UserContext";

import modelZemljovidi from "@/models/zemljovidi";
import modelComments from "@/models/komentari";

import ZemljovidDialog from "./ZemljovidDialog";
import CommentDialog from "@/views/Komentari/CommentDialog";

function ZemljovidiPage() {
  const userContext = useContext(UserContext);

  const komentriForm = userContext?.hasAnyPermission([Permissions.HGSSMod]) ? "update-hgss"
  : userContext?.hasAnyPermission([Permissions.HPSMod]) ? "update-hps" 
  : "default";

  const allowEdit = userContext?.hasAnyPermission([Permissions.HGSSMod]);


  return (
    <DataCentricPage
      needPermission={[Permissions.HGSSRead]}

      primaryModel={modelZemljovidi}
      primaryTitleToken="titles.zemljovidi"
      primaryView="default"
      primaryAllowView
      primaryAllowEdit={allowEdit}
      primaryDialogComponent={ZemljovidDialog}
      primaryDialogForm="default"

      secondaryModel={modelComments}
      secondaryTitleToken="titles.komentari"
      secondaryView="related_komentari"
      secondaryAllowView
      secondaryAllowEdit={allowEdit}
      secondaryDialogComponent={CommentDialog}
      secondaryDialogForm={komentriForm}

      baseRecordPath={modelZemljovidi.apiPath}
      childRecordRelativePath="komentari"
      geomRelativePath=""

      mapId={5}
      mapModel={modelZemljovidi}
    />
  );
}

export default ZemljovidiPage;
